<template>
  <div class="login" v-if="!isSsoLogin && !ssoAuthorizeCode">
    <div class="header">
      <van-image class="img" :src="require('@/assets/images/home/nfclass_logo.0c4a260.png')"/>
      <div class="text" @click="$router.push({name:'Home'})">暂不登录</div>
    </div>
    <div class="box">
      <div class="form">
        <van-form ref="form">
          <van-field
            v-model="username"
            placeholder="请输入手机号码或邮箱"
            :clearable="true"
          >
            <template #left-icon>
              <img :src="require('@/assets/images/icon_account_02.png')" alt="">
            </template>
          </van-field>
          <van-field
            class="passwordWrap"
            v-model="password"
            type="password"
            placeholder="请输入登录密码"
            :clearable="true"
          >
            <template #left-icon>
              <img :src="require('@/assets/images/icon_lock_04.png')" alt="">
            </template>
          </van-field>
          <van-field
            class="passwordWrap"
            v-model="imageCodeInput"
            type="text"
            placeholder="请输入验证码"
            :clearable="true"
          >
            <template #right-icon>
              <img style="height: 30px" :src="imageCode" alt="" @click="refreshCode">
            </template>
          </van-field>
        </van-form>
        <div class="forget" @click="$router.push({ name: 'Forget' })">忘记密码？</div>
        <div class="btnWrap">
          <button class="login" @click="login">登录</button>
          <button class="register" @click="$router.push({ name: 'Register' })">注册</button>
        </div>
        <div class="weChat" @click="weChatLogin">
          <div class="icon"></div>
          微信账号登录
        </div>
      </div>
    </div>
    <div class="checkbox">
      <span @click="checked = !checked" :class="{checked}"></span>
      勾选即代表你已经同意
      <sub class="link" @click="$router.push({ name:'HelpCenter', params: { type : 4 } });">《用户服务协议》</sub>和
      <sub class="link" @click="$router.push({ name:'HelpCenter', params: { type : 9 } });">《隐私政策》</sub>
    </div>
  </div>
</template>

<script>
import md5 from 'md5';
import { Form, Field } from 'vant';
export default {
  name: 'Login',
  components: { 'van-form': Form, 'van-field': Field },
  data () {
    return {
      username: '',
      password: '',
      checked: false,
      imageCode: null,
      imageCodeInput: null
    };
  },
  computed:{
    isSsoLogin(){
      return this.$route.query.sso_test
    },
    ssoAuthorizeCode(){
      return this.$route.query.code
    }
  },
  async mounted () {
    const { $router,$route: { query: { status, redirect } } } = this;
    // 登录前先保存重定向地址
    if (redirect && redirect !== '') {
      sessionStorage.setItem('redirectAfterLogin', redirect);
    }
    // ========= sso登录 =========
    const { $utils } = this;
    if (this.ssoAuthorizeCode) {
      await this.$http
        .get("security/ssoLogin?code=" + this.$route.query.code)
        .then((res) => {
          const { token } = res.data || {};
          $utils.successToast({
            message: '登录成功',
            onClose: () => {
              $router.push({name: 'Home', query: {token: token}});
            }
          });
        })
        .catch(err => {
          $utils.failToast.error("登录失败!" + err.msg)
        })
    } else if(this.isSsoLogin) {
      await this.$http
        .get("security/ssoAuthorizeUrl")
        .then(res => {
          window.location.href = res.data.ssoAuthorizeUrl
        })
        .catch(err => {
          $utils.failToast("获取SSO授权地址失败!")
        })
    }
    // ========= sso登录 =========
    this.status = status * 1;
    this.getImageCode();
  },

  methods: {
    refreshCode () {
      this.getImageCode();
    },
    getImageCode () {
      this.$http.get('security/imageValidateCode', { params: { t: Math.random() }, responseType: 'arraybuffer' })
        .then((res) => {
          this.imageCode = `data:image/jpg;base64, ${window.btoa(new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), ''))}`;
        })
        .catch((err) => {
          console.log('获取验证码发生错误', err);
        });
    },
    login () {
      const { $utils, username, password } = this;
      if ($utils.verifyEmpty(username, '请输入手机号码或邮箱') && $utils.verifyEmpty(password, '请输入登录密码')) {
        this.$http.post('security/login', { username, password: md5(password), imageValidateCode: this.imageCodeInput }, { showLoading: true, loadingText: '登录中...' }).then((res) => {
          const { token } = res.data || {};
          $utils.successToast({
            message: '登录成功',
            onClose: () => {
              window.location.href = `/api/wechat/getOpenid?state=${encodeURIComponent(token)}`;
            }
          });
        });
      }
    },

    /* 微信登录 */
    weChatLogin () {
      const { $utils, checked } = this;
      if ($utils.verifyEmpty(checked, '请勾选用户服务协议和隐私政策协议')) {
        window.location.href = '/api/wechat/openid/authorizedLogin?state=guangdongchubanshe';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100vh;
  background: url('~@/assets/images/image_bg.png') no-repeat center center;
  .header {
    width: 100%;
    height: 280px;
    color: #333;
    position: relative;
    font-size: 28px;
    color: #FFFFFF;
    .img{
      position: absolute;
      left: 15%;
      right: 0;
      top: 20%;
      width: 70%;
      height: auto;
    }
    .text{
      position: relative;
      padding: 24px 28px;
      text-align: right;
    }
  }
  .box {
    margin: 0 auto;
    width: 690px;
    border-radius: 40px;
    overflow: hidden;
    .form {
      width: 536px;
      margin: 60px auto 0;
      .passwordWrap {
        margin-top: 20px;
      }
      .van-field {
        background: #FFFFFF;
        height: 84px;
        box-shadow: 0px 0px 60px rgba(85, 164, 255, 0.08);
        border-radius: 10px;
        /deep/ .van-field__left-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 26px 20px;
          img {
            width: 24px;
            height: 30px;
          }
        }
        /deep/ input::-webkit-input-placeholder {
            color :  #999 ;
        }
        /deep/ input:-ms-input-placeholder { // IE 10 +
            color :  #999 ;
        }
        /deep/ input:-moz-placeholder { // Firefox 4 -18
            color :  #999 ;
        }
        /deep/ input::-moz-placeholder { // Firefox 19 +
            color :  #999 ;
        }
      }
      .forget {
        margin-top: 20px;
        width: 100%;
        text-align: right;
        font-size: 24px;
        font-weight: 500;
        line-height: 34px;
        color: #999999;
      }
      .btnWrap {
        margin-top: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .login {
          width: 450px;
          height: 76px;
          background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
          box-shadow: 0px 6px 40px rgba(95, 169, 255, 0.3);
          border-radius: 44px;
          color: #fff;
          font-weight: 500;
          line-height: 46px;
          font-size: 28px;
        }
        .register {
          margin-top: 20px;
          width: 450px;
          height: 76px;
          font-size: 28px;
          color: #5FA9FF;
          border: 2px solid #5FA9FF;
          background: transparent;
          border-radius: 44px;
        }
      }
      .weChat{
        width: 270px;
        height: 64px;
        border: 2px solid #07D068;
        border-radius: 44px;
        font-size: 24px;
        color: #07D068;
        margin: 80px auto 0;
        display: flex;
        padding: 12px 32px;
        align-items: center;
        .icon{
          width: 40px;
          height: 40px;
          margin-right: 12px;
          background-size: contain;
          background-image: url('~@/assets/images/icon_weChat.png');
        }
      }
    }
  }
  .checkbox {
    margin: 66px auto 0;
    height: 32px;
    font-size: 22px;
    font-weight: 500;
    color: #999;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: inline-block;
      width: 28px;
      height: 28px;
      background-color: #fff;
      border: 1px #ccc solid;
      margin-right: 10px;
      margin-top: 4px;
    }
    .link{
      color: #5BA7FF;
    }
    .checked {
      border: none;
      background: url('~@/assets/images/icon_checked_01.png') no-repeat center center/cover;
    }
  }
}
</style>
